import { Button, Form, Input, Select } from "antd";
import "./styles/emailTesting.css";
import { useEffect, useState } from "react";
import config from "../../../config";
const base_url = config.base_url;

function EmailTesting() {
  const [form] = Form.useForm();
  const [emailList, setEmailList] = useState([]);
  useEffect(() => {
    form.setFieldsValue({ email: "tomero@ostreon.io" });
  }, []);
  const onSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        await fetch(base_url + "admin/email/send", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `user_id=${values.user_id}&email=${values.email}&id=${values.templateNumber}`,
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  useEffect(() => {
    fetch(base_url + "admin/email/list", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) return res.json();
      })
      .then((data) => {
        setEmailList(data);
      });
  }, []);
  useEffect(() => {
    console.log(form);
  }, [form]);
  return (
    <div className="mainn">
      <h2 className="title">QA</h2>
      <Form onFinish={onSubmit} className="form" form={form}>
        <p className="form_title">Email Templates Tests</p>
        <Form.Item
          style={{
            width: "30%",
          }}
          labelCol={{ span: 24 }}
          name="user_id"
          label="User ID"
          rules={[
            {
              required: true,
            },
          ]}
          required
        >
          <Input className="userid_input" placeholder="User ID" />
        </Form.Item>
        <Form.Item
          style={{
            width: "30%",
          }}
          labelCol={{ span: 24 }}
          label="Email address to send to"
          name="email"
          rules={[
            {
              required: true,
            },
          ]}
          required
        >
          <Select className="email_input" placeholder="User ID">
            <Select.Option value="tomero@ostreon.io">
              tomero@ostreon.io
            </Select.Option>
            <Select.Option value="julienk@ostreon.io">
              julienk@ostreon.io
            </Select.Option>
            <Select.Option value="xabiereiza@gmail.com">
              xabiereiza@gmail.com
            </Select.Option>
            <Select.Option value="mohamedismmaiel@gmail.com">
              mohamedismmaiel@gmail.com
            </Select.Option>
          </Select>
        </Form.Item>
        <div className="buttonContainer">
          <Form.Item
            style={{
              width: "59%",
            }}
            labelCol={{ span: 24 }}
            label="Email template number"
            rules={[
              {
                required: true,
              },
            ]}
            required
            name="templateNumber"
          >
            <Input
              placeholder="Email template number"
              className="email_template"
            />
          </Form.Item>
          <Button
            onClick={() => {
              form.submit();
            }}
            className="send_button"
            style={{
              marginTop: "20px",
            }}
          >
            Send Email
          </Button>
        </div>
      </Form>
      <div
        className="content"
        style={{
          height: "max-content",
          padding: "20px 0",
          backgroundColor: "transparent",
          textAlign: "left",
        }}
      >
        <h3>Email templates titles and numbers:</h3>
        <ul type="1">
          {emailList?.map((email) => {
            return (
              <li>
                {email?.id} - {email?.subject}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
export default EmailTesting;
